import React from 'react';

import { ALBUM_SUBTYPE } from '../../../../../constants/albums';
import { EVENT_ADDON_ITEM_TYPE } from '../../../../../constants/event-items';
import { getAsset } from '../../../../../util/assets';

export const FREEMIUM_EVENT_STEPS = {
  LANDING_PAGE: 'LANDING_PAGE',
  DETAILS: 'DETAILS',
  ALBUMS: 'ALBUMS',
  PERMISSIONS: 'PERMISSIONS',
  JOIN_CODE: 'JOIN_CODE',
  SOCIAL: 'SOCIAL',
  UPGRADE: 'UPGRADE',
  UPGRADE_BUNDLE: 'UPGRADE_BUNDLE',
  REVIEW: 'REVIEW',
  REGISTRATION: 'REGISTRATION',
  PHONE_VERIFICATION: 'PHONE_VERIFICATION',
  EMAIL_PIN_VERIFICATION: 'EMAIL_PIN_VERIFICATION',
  SKU_SELECTION: 'SKU_SELECTION',
  WALDOFICATION: 'WALDOFICATION',
  SUBSCRIPTION_UPSELL: 'SUBSCRIPTION_UPSELL',
};

export const freemiumEventCreateWizardStrings = {
  [ALBUM_SUBTYPE.BIRTHDAYS]: {
    createWizardHeader: 'Creating birthday event',
    detailsStepBubble: 'Let’s start setting up your birthday event!',
    [EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK]: {
      createWizardHeader: 'Creating birthday Memories Smart Slideshow',
    },
    [EVENT_ADDON_ITEM_TYPE.GROUP_VIDEO]: {
      createWizardHeader: 'Creating birthday Group Video',
    },
  },
  [ALBUM_SUBTYPE.ANNIVERSARIES]: {
    createWizardHeader: 'Creating anniversary event',
    detailsStepBubble: 'Let’s start setting up your anniversary event!',
    [EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK]: {
      createWizardHeader: 'Creating anniversary Memories Smart Slideshow',
    },
    [EVENT_ADDON_ITEM_TYPE.GROUP_VIDEO]: {
      createWizardHeader: 'Creating anniversary Group Video',
    },
  },
  [ALBUM_SUBTYPE.GRADUATIONS]: {
    createWizardHeader: 'Creating graduation event',
    detailsStepBubble: 'Let’s start setting up your graduation event!',
    [EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK]: {
      createWizardHeader: 'Creating graduation Memories Smart Slideshow',
    },
    [EVENT_ADDON_ITEM_TYPE.GROUP_VIDEO]: {
      createWizardHeader: 'Creating graduation Group Video',
    },
  },
  [ALBUM_SUBTYPE.MEMORIALS]: {
    createWizardHeader: 'Creating memorial event',
    detailsStepBubble: 'Let’s set up your memorial event together',
    [EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK]: {
      createWizardHeader: 'Creating memorial Memories Smart Slideshow',
    },
    [EVENT_ADDON_ITEM_TYPE.GROUP_VIDEO]: {
      createWizardHeader: 'Creating memorial Group Video',
    },
  },
  [ALBUM_SUBTYPE.VACATIONS]: {
    createWizardHeader: 'Creating vacation event',
    detailsStepBubble: 'Let’s start setting up your vacation event!',
    [EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK]: {
      createWizardHeader: 'Creating vacation Memories Smart Slideshow',
    },
    [EVENT_ADDON_ITEM_TYPE.GROUP_VIDEO]: {
      createWizardHeader: 'Creating vacation Group Video',
    },
  },
  [ALBUM_SUBTYPE.FUNDRAISERS]: {
    createWizardHeader: 'Creating fundraiser event',
    detailsStepBubble: 'Let’s start setting up your fundraiser event!',
    [EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK]: {
      createWizardHeader: 'Creating fundraiser Memories Smart Slideshow',
    },
    [EVENT_ADDON_ITEM_TYPE.GROUP_VIDEO]: {
      createWizardHeader: 'Creating fundraiser Group Video',
    },
  },
  [ALBUM_SUBTYPE.CUSTOM_EVENT]: {
    createWizardHeader: 'Creating custom event',
    detailsStepBubble:
      'Let’s get to sharing life’s memories with those who matter most!',
    [EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK]: {
      createWizardHeader: 'Creating Memories Smart Slideshow',
    },
    [EVENT_ADDON_ITEM_TYPE.GROUP_VIDEO]: {
      createWizardHeader: 'Creating Group Video',
    },
  },

  [ALBUM_SUBTYPE.WEDDINGS]: {
    createWizardHeader: 'Creating a wedding event',
    detailsStepBubble: (
      <>Tell us more about your wedding so we can tailor your experience!</>
    ),
    [EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK]: {
      createWizardHeader: "Creating your wedding's Memories Smart Slideshow",
    },
    [EVENT_ADDON_ITEM_TYPE.GROUP_VIDEO]: {
      createWizardHeader: "Creating your wedding's Group Video",
    },
  },
};

export const EVENT_ADDON_ITEMS_META = {
  [EVENT_ADDON_ITEM_TYPE.WALDOFIED]: {
    title: 'Gold',
    standaloneTitle: subType => {
      switch (subType) {
        case ALBUM_SUBTYPE.WEDDINGS:
          return 'Live Wedding Day Album';
        case ALBUM_SUBTYPE.MEMORIALS:
          return 'Service & Reception Album';
        default:
          return 'Live Event Album';
      }
    },
    description: 'Gather and share precious photos and videos from the event!',
    howItWorks: {
      header: 'How it works:',
      assetUrl: getAsset('/live-slideshows-how-it-works.gif'),
    },
    reviewTitle: 'Gold with Live Slideshow',
    tileCover: getAsset(
      '/freemium-event-config/digital-photo-gallery-tile.png',
    ),
  },
  [EVENT_ADDON_ITEM_TYPE.WALDOFIED_PRO]: {
    title: 'Gold',
    description: 'Gather and share precious photos and videos from the event!',
    reviewTitle: 'Gold with Live Slideshow',
    tileCover: getAsset(
      '/freemium-event-config/digital-photo-gallery-tile.png',
    ),
  },
  [EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK]: {
    title: 'Memories Slideshow',
    description:
      'Easily gather old photos of the celebrated from others and turn them into a beautiful, chronological slideshow. Perfect for rehearsal dinners!',
    howItWorks: {
      header: 'How it works:',
      assetUrl: getAsset('/memory-book-how-it-works.gif'),
    },
    tileCover: getAsset('/freemium-event-config/memory-book-tile.png'),
  },
  [EVENT_ADDON_ITEM_TYPE.GROUP_VIDEO]: {
    title: 'Group Video',
    description: 'Gather 30-second videos from your friends & family!',
    howItWorks: {
      header: 'How it works:',
      assetUrl: getAsset('/gv-how-it-works.gif'),
    },
    tileCover: getAsset('/freemium-event-config/group-video-tile.png'),
  },
  VIDEO_GUESTBOOK: {
    title: 'Video Guestbook',
    description: 'Gather 30-second well wishes from your guests!',
    howItWorks: {
      header: 'How it works:',
      assetUrl: getAsset('/vgb-how-it-works.gif'),
    },
    tileCover: getAsset('/freemium-event-config/group-video-tile.png'),
  },
  [`${EVENT_ADDON_ITEM_TYPE.GROUP_VIDEO},${EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK}`]:
    {
      title: (
        <>
          Group Video &<br />
          Memories Slideshow
        </>
      ),
      tileCover: getAsset(
        `/freemium-event-config/memory-book-group-video-tile.png`,
      ),
      badgeLabel: 'BUNDLE',
      priceLabel: (
        <>
          <span className="text-xs">
            <s>$99.98</s>
          </span>{' '}
          <span className="text-extra-bold">$49.99 only</span>{' '}
        </>
      ),
    },
  [`VIDEO_GUESTBOOK,${EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK}`]: {
    title: (
      <>
        Video Guestbook &<br />
        Memories Slideshow
      </>
    ),
    tileCover: getAsset(
      `/freemium-event-config/memory-book-group-video-tile.png`,
    ),
    badgeLabel: 'BUNDLE',
    priceLabel: (
      <>
        <span className="text-xs">
          <s>$99.98</s>
        </span>{' '}
        <span className="text-extra-bold">$49.99 only</span>{' '}
      </>
    ),
  },
  PHOTO_ALBUMS: {
    title: 'Digital Photo Gallery',
    description: 'Gather and share precious photos and videos from the event!',
    howItWorks: {
      header:
        'Private and secure. Accessible only through your custom QR code and sharing link.',
      assetUrl: getAsset('/photo-albums-how-it-works.gif'),
      footer:
        'Share, comment, like/react, and more in a private space dedicated to your event',
    },
    tileCover: getAsset(
      '/freemium-event-config/digital-photo-gallery-tile.png',
    ),
  },
  PHOTO_DELIVERY: {
    title: 'Automated smart face-tagging photo delivery',
    howItWorks: {
      header:
        'Save time. Save sanity. Secure Al-powered photo delivery to everyone',
      assetUrl: getAsset('/photo-delivery-how-it-works.gif'),
      footer:
        'Upload your selfie and automatically get matches via text or notification.',
    },
  },
  LIVE_SLIDESHOWS: {
    title: 'Live smart slideshow',
    howItWorks: {
      header:
        'Share photos on the big screen in real-time. Perfect for your wedding day reception!',
      assetUrl: getAsset('/live-slideshows-how-it-works.gif'),
    },
  },
};
